import React, { useEffect, useRef, useCallback } from 'react';
import http from "./Http";

const WebSocketController = ({ onError, onData, SNs, baseUrl }) => {
  const wss = useRef(null);
  const reconnectAttempts = useRef(0);
  const isMounted = useRef(true);
  // const previousSNs = useRef(SNs);

  // 生成WebSocket连接URL
  const generateWebSocketUrl = useCallback(() => {
    const params = new URLSearchParams({
      SNs: SNs.join(','),
      Token: http.token,
    });
    return `${baseUrl}?${params}`;
  }, [SNs]);

  // 处理错误统一方法
  const handleError = useCallback(
    (error) => {
      const errorObj = typeof error === 'string' ? new Error(error) : error;
      onError(errorObj);
      console.error('WebSocket Error:', errorObj);
    },
    [onError]
  );

  // 初始化WebSocket连接
  const connect = useCallback(() => {
    try {
      const url = generateWebSocketUrl();
      if (url == ""){
        return;
      }
      wss.current = new WebSocket(url);

      wss.current.onopen = () => {
        reconnectAttempts.current = 0;
        console.log('WebSocket connected');
      };

      wss.current.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          onData(data);
        } catch (error) {
          handleError(new Error('Failed to parse WebSocket message'));
        }
      };

      wss.current.onerror = (event) => {
        handleError(new Error('WebSocket error occurred'));
      };

      wss.current.onclose = (event) => {
        if (!isMounted.current) return;
        
        console.log(`WebSocket closed: ${event.reason}`);
        if (event.code !== 1000) { // 1000表示正常关闭
          const delay = Math.min(1000 * Math.pow(2, reconnectAttempts.current), 30000);
          setTimeout(() => {
            if (isMounted.current) {
              reconnectAttempts.current += 1;
              connect();
            }
          }, delay);
        }
      };
    } catch (error) {
      handleError(new Error('Failed to initialize WebSocket connection'));
    }
  }, [generateWebSocketUrl, handleError, onData]);

  // 清理函数
  const cleanup = useCallback(() => {
    if (wss.current) {
      wss.current.onclose = null; // 禁用自动重连
      wss.current.close();
      wss.current = null;
    }
    isMounted.current = false;
  }, []);

  // 主效果函数
  useEffect(() => {
    connect();
    
    // 心跳检测
    const heartbeatInterval = setInterval(() => {
      if (wss.current?.readyState === WebSocket.OPEN) {
        wss.current.send(JSON.stringify({ type: 'ping' }));
      }
    }, 30000);

    return () => {
      cleanup();
      clearInterval(heartbeatInterval);
    };
  }, [SNs]);

  // SNs变化时重新连接
  // useEffect(() => {
  //   if (JSON.stringify(previousSNs.current) !== JSON.stringify(SNs)) {
  //     previousSNs.current = SNs;
  //     if (wss.current) {
  //       cleanup();
  //       connect();
  //     }
  //   }
  // }, [SNs, cleanup, connect]);

  return <div></div>; 
};

export default WebSocketController;